import React from 'react'
import { Color23, Colors23 } from '@grammarly/badger-ui'

interface PauseIconProps {
  fill?: string
  color?: Color23
}

export const PauseIcon: React.FC<PauseIconProps> = ({ fill = 'none', color }) => {
  const foregroundColor = color ? Colors23[color] : '#565B6C'

  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill={fill} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g clipPath="url(#clip0_2_213)">
        <circle cx="16" cy="16" r="15" stroke={foregroundColor} strokeWidth="2" />
        <rect x="20" y="10" width="12" height="2" rx="1" transform="rotate(90 20 10)" fill={foregroundColor} />
        <rect x="14" y="10" width="12" height="2" rx="1" transform="rotate(90 14 10)" fill={foregroundColor} />
      </g>
      <defs>
        <clipPath id="clip0_2_213">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
